export default __webpack_public_path__ + "static/media/empty-calendar.07e0f45a.svg";